import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';
import { Observable } from 'rxjs';

/**
 * Forwarding Admin Guard
 * Allows access to: Admin, ForwardingAdmin
 * Usage: canActivate: [forwardingAdminGuard]
 */
export const forwardingAdminGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.userRole$.pipe(
    take(1),
    map(role => {
      if (!role) {
        console.warn('ForwardingAdminGuard: No user role found');
        router.navigate(['/dashboard']);
        return false;
      }

      const normalizedRole = role.toLowerCase();
      const hasAccess = normalizedRole === 'admin' || normalizedRole === 'forwardingadmin';

      if (!hasAccess) {
        console.warn(`ForwardingAdminGuard: Access denied for role '${role}'`);
        router.navigate(['/dashboard/forwarding']);
      }

      return hasAccess;
    })
  );
};

/**
 * Forwarding User Guard
 * Allows access to: Admin, ForwardingAdmin, ForwardingUser
 * Usage: canActivate: [forwardingUserGuard]
 */
export const forwardingUserGuard: CanActivateFn = (route, state): Observable<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.userRole$.pipe(
    take(1),
    map(role => {
      if (!role) {
        console.warn('ForwardingUserGuard: No user role found');
        router.navigate(['/dashboard']);
        return false;
      }

      const normalizedRole = role.toLowerCase();
      const hasAccess = normalizedRole === 'admin' ||
                       normalizedRole === 'forwardingadmin' ||
                       normalizedRole === 'forwardinguser';

      if (!hasAccess) {
        console.warn(`ForwardingUserGuard: Access denied for role '${role}'`);
        router.navigate(['/dashboard']);
      }

      return hasAccess;
    })
  );
};
